var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
var AVATAR_STYLE = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
};
var AVATAR_INITIALS_STYLE = {
    margin: 0,
    padding: 0,
    display: 'inline',
    textAlign: 'center',
    fontWeight: 'bold',
};
function UserAvatar(_a) {
    var initials = _a.initials, _b = _a.size, size = _b === void 0 ? 30 : _b, _c = _a.color, color = _c === void 0 ? '#001024' : _c, _d = _a.backgroundColor, backgroundColor = _d === void 0 ? '#F2F4F9' : _d, _e = _a.fontSize, fontSize = _e === void 0 ? 11 : _e, containerStyle = _a.containerStyle;
    var container = __assign(__assign(__assign({}, AVATAR_STYLE), containerStyle), { width: size, height: size, borderRadius: size / 2, backgroundColor: backgroundColor, flexShrink: 0 });
    var text = __assign(__assign({}, AVATAR_INITIALS_STYLE), { fontSize: fontSize, color: color });
    return (React.createElement("span", { style: container },
        React.createElement("p", { style: text }, initials.toUpperCase())));
}
export default UserAvatar;
